import isMountedMixin from 'vue/mixins/is-mounted';
import uuidMixin from 'vue/mixins/uuid';


export default {
    mixins: [
        uuidMixin,
        isMountedMixin,
    ],
    props: {
        facet: String,
        hasFloatingLabel: Boolean,
        type: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            default() {
                return `v-uid-${ this.uuid }`;
            },
        },
        value: {
            type: String,
            required: true,
        },
        state: {
            type: Object,
            default() {
                return {
                    error: false,
                    required: false,
                    disabled: false,
                    focus: false,
                };
            },
        },
        label: String,
        placeholder: String,
        messages: {
            type: Object,
            default() {
                return {
                    error: [],
                };
            },
        },
    },
    data() {
        return {
            hasFocus: this.state.focus,
        };
    },
    computed: {
        rootClasses() {
            const classes = {
                'form-field__floating-label': this.hasFloatingLabel,
                'form-field__is-required': this.state.required,
                'form-field__is-disabled': this.state.disabled,
                'form-field__has-error': this.state.error,
            };

            // NOTE: Extend the form clesses adding also the floating variants
            if (this.hasFloatingLabel) {
                const isFloating = this.placeholder || this.value || this.hasFocus || this.state.disabled;
                classes['form-field__is-floating'] = isFloating;
            }

            return Object.assign(classes, this.specificRootClasses);
        },
        inputBindings() {
            const { id, state, value } = this;
            const { disabled, required } = state || {};

            return Object.assign({
                id,
                name: id,
                disabled,
                required,
                value,
            }, this.specificInputBindings);
        },
        actionCount() {
            let count = 0;
            count += (this.type === 'date' ? 1 : 0);

            return count;
        },
    },
    methods: {
        onFocus() {
            this.hasFocus = true;
        },
        onBlur() {
            this.hasFocus = false;
        },
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/form/form-field-abstract/index.js